import React from 'react';

import { Box, Checkbox, HStack, Radio, Stack } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { StopSignLabel } from 'components/DataDisplay';
import { QuestionCircleIcon } from 'components/Icons';

export const renderRadioButton = (
  label,
  subLabel,
  key,
  labelColor = customTheme.colors.gray['300'],
) => {
  return (
    <Stack spacing={0}>
      <Radio value={key} size="lg">
        <Box fontSize="md" color={labelColor}>
          {label}
        </Box>
      </Radio>
      <Box fontSize="sm" color={customTheme.colors.gray[250]} pl={7}>
        {subLabel}
      </Box>
    </Stack>
  );
};

export const stopSignWithMessage = (
  stopSignLabel: string,
  label: string,
  isChecked: boolean,
  setIsConfirm: (checked: boolean) => void,
  onClick?: () => void,
  isDisabled = false,
) => {
  return (
    <Stack spacing={4}>
      <StopSignLabel label={stopSignLabel} />
      <HStack>
        <Checkbox
          isDisabled={isDisabled}
          size="lg"
          isChecked={isChecked}
          onChange={e => {
            setIsConfirm(e?.target?.checked);
          }}
        />
        <HStack
          color={isDisabled ? customTheme.colors.gray['200'] : 'primary'}
          cursor="pointer"
          onClick={onClick}
        >
          <Box>{label}</Box>
          <Box boxSize={4}>
            <QuestionCircleIcon />
          </Box>
        </HStack>
      </HStack>
    </Stack>
  );
};
